import { fromJS, Map } from 'immutable';
import actionTypes from 'constants/publishersConstants';
import { flatten, values } from 'lodash';

const initialEventEligibility = {
  validCategory: null, validLocation: null, eligible: null, isLoading: false
};

export const initialState = fromJS({
  data: { global: []},
  totalCount: 0,
  isLoading: false,
  eventEligibility: initialEventEligibility
});

function isLoading(state, action) {
  switch(action.type) {
    case actionTypes.FETCH_PUBLISHERS_REQUEST:
      return true;
    case actionTypes.FETCH_PUBLISHERS_SUCCESS:
    case actionTypes.FETCH_PUBLISHERS_FAILURE:
      return false;
    default:
      return state;
  }
}

function data(state, action) {
  switch(action.type) {
    case actionTypes.FETCH_PUBLISHERS_SUCCESS:
      return fromJS(action.payload);
    default:
      return state;
  }
}

function countPublishers(state, action) {
  switch(action.type) {
    case actionTypes.FETCH_PUBLISHERS_SUCCESS:
      return flatten(values(action.payload)).length;
    default:
      return state;
  }
}

function eventEligibility(state, action){
  switch(action.type) {
    case actionTypes.FETCH_EVENT_ELIGIBILITY_REQUEST:
      return fromJS({...initialEventEligibility, isLoading: true });
    case actionTypes.FETCH_EVENT_ELIGIBILITY_SUCCESS:
      return fromJS({ ...action.payload, isLoading: false });
    case actionTypes.FETCH_EVENT_ELIGIBILITY_ERROR:
      return fromJS({...initialEventEligibility }) ;
    default:
      return state;
  }
}
const publishersReducer = (state = initialState, action) => {
  return Map({
    data: data(state.get('data'), action),
    totalCount: countPublishers(state.get('totalCount'), action),
    isLoading: isLoading(state.get('isLoading'), action),
    eventEligibility: eventEligibility(state.get('eventEligibility'), action)
  });
};

export default publishersReducer;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/publishersReducer.js